export default {
      id: "mail-usage",
      viewBox: "0 0 24 19",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#mail",
      toString: function () {
        return this.url;
      }
    }